// src/jira/issue-search-view/types.ts
var JiraIssueSearchViewAriResourceOwner = "jira", JiraIssueSearchViewAriResourceType = "issue-search-view";

export {
  JiraIssueSearchViewAriResourceOwner,
  JiraIssueSearchViewAriResourceType
};
